import React, { createContext, useState, ReactNode, useEffect } from 'react';

import axios from 'axios';
import { ConfigContextType } from './types/configContextType';
import { CONFIG_ENDPOINTS, CREDITS_ENDPOINTS } from '../config/apiEndpoints';
import useAuth from '../hooks/useAuth';
import { Config } from '../data_models/config';


// Create the context
export const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

interface ConfigProviderProps {
    children: ReactNode;
}

// Provider component
export const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {

    const [config, setConfig] = useState<Config | undefined>(undefined);


    useEffect(() => {
        try {
            fetchConfig();
        } catch (error) {
        }

    }, []);


    const fetchConfig = async () => {
        try {
            const response = await axios.get(`${CONFIG_ENDPOINTS.GET_CONFIG}`,
                {}
            );
            setConfig(response.data || undefined);
        } catch (error) {
        }
    }


    return (
        <ConfigContext.Provider value={{
            config,
        }}>
            {children}
        </ConfigContext.Provider>
    );
};
